var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4287 7.32227H1.57157C1.493 7.32227 1.42871 7.38655 1.42871 7.46512V8.53655C1.42871 8.61512 1.493 8.67941 1.57157 8.67941H14.4287C14.5073 8.67941 14.5716 8.61512 14.5716 8.53655V7.46512C14.5716 7.38655 14.5073 7.32227 14.4287 7.32227Z",
    fill: "#4A4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.8de2b70b2d1ecd985e6664d7e9bfd540.svg";
export { ForwardRef as ReactComponent };